import { DtoBase } from '../../../types/Dtos/DtoBase'

export class CreateFolderDto extends DtoBase {
  constructor(name: string, parentId: string) {
    super({ name, parentId })
  }
}
